export default function QuickSizePicks({ label, sizes, onPick, activeValue }) {
  if (!sizes?.length) return null;

  return (
    <div>
      <p className="text-xs text-slate-500 mb-2">{label}</p>
      <div className="flex flex-wrap gap-2">
        {sizes.map((size) => (
          <button
            key={size}
            type="button"
            onClick={() => onPick(size)}
            className={`rounded-full px-3 py-1.5 text-sm font-medium border transition-all ${
              activeValue === size
                ? 'bg-emerald-600/20 border-emerald-500 text-emerald-300'
                : 'bg-slate-900 border-slate-600 text-slate-300 hover:border-emerald-600/60 hover:text-white'
            }`}
          >
            {size}
          </button>
        ))}
      </div>
    </div>
  );
}
